export enum ListName {
  HideIntro2024Q1 = "HideIntro2024Q1",
  FinishedOnboarding2025Q2 = "FinishedOnboarding2025Q2",
  Trading = "Trading",
  Transfers = "Transfers",
}
